import { useEffect, useState } from "react";
import axios from "axios";

function fmtFecha(fecha) {
    if (!fecha) return "—";
    return new Date(fecha).toLocaleString("es-CO", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
}

function fmtMonto(n) {
    if (!n) return null;
    return "$" + new Intl.NumberFormat("es-CO").format(n);
}

const LABEL_ORDENAR = {
    mejor_calificados: "Mejor calificados",
    mas_recientes: "Más recientes",
    precio_asc: "Precio ascendente",
    precio_desc: "Precio descendente",
};

const CATEGORIAS_BUSQUEDA = [
    "Veterinaria", "Mascotas", "Lavandería", "Jardinería", "Aseo",
    "Educación", "Construcción", "Transporte", "Eventos", "Legal",
    "Belleza", "Salud", "Digital", "Floristería", "Chef a domicilio",
    "Deporte & Fitness", "Hogar & Reparaciones", "Fotografía & Video",
    "Peluquería & Barbería", "Contabilidad & Finanzas", "Cuidado de personas",
    "Bienestar & Espiritualidad", "Marketing & Publicidad", "Tecnología & Soporte",
];

function Busquedas() {
    const [busquedas, setBusquedas]           = useState([]);
    const [cargando, setCargando]             = useState(true);
    const [pagina, setPagina]                 = useState(1);
    const [paginas, setPaginas]               = useState(1);
    const [total, setTotal]                   = useState(0);
    const [soloConFiltros, setSoloConFiltros] = useState(false);
    const [soloConUsuario, setSoloConUsuario] = useState(false);
    const [palabraInput, setPalabraInput]     = useState("");
    const [palabra, setPalabra]               = useState("");
    const [categoria, setCategoria]           = useState("");

    useEffect(() => {
        (async () => {
            try {
                setCargando(true);
                const res = await axios.post("/listar-busquedas-admin", { params: { pagina, soloConFiltros, soloConUsuario, palabra, categoria } });
                setBusquedas(res?.data?.busquedas || []);
                setTotal(res?.data?.total || 0);
                setPaginas(res?.data?.paginas || 1);
            } catch {
                setBusquedas([]);
            } finally {
                setCargando(false);
            }
        })();
    }, [pagina, soloConFiltros, soloConUsuario, palabra, categoria]);

    function toggleFiltro() {
        setSoloConFiltros(v => !v);
        setPagina(1);
    }

    function buscarPalabra(e) {
        e.preventDefault();
        setPalabra(palabraInput.trim());
        setPagina(1);
    }

    function cambiarCategoria(e) {
        setCategoria(e.target.value);
        setPagina(1);
    }

    function limpiarTodo() {
        setSoloConFiltros(false);
        setSoloConUsuario(false);
        setPalabraInput("");
        setPalabra("");
        setCategoria("");
        setPagina(1);
    }

    const hayFiltros = soloConFiltros || soloConUsuario || palabra || categoria;

    function cambiarPagina(p) {
        setPagina(p);
        window.scrollTo({ top: 0, behavior: "smooth" });
    }

    return (
        <div className="container-fluid">
            <div className="pt-3 pb-2 mb-4 border-bottom">
                <h1 className="h2 text-dark mb-1">Búsquedas</h1>
                <p className="text-muted mb-0 small">Historial de búsquedas realizadas por los usuarios en la app.</p>
            </div>

            <div className="mb-3 d-flex flex-column gap-2">
                {/* Fila 1: texto libre */}
                <form className="d-flex gap-2 align-items-center" onSubmit={buscarPalabra}>
                    <span className="text-muted small fw-semibold flex-shrink-0" style={{ fontSize: "0.8rem", minWidth: 80 }}>Palabra:</span>
                    <input
                        type="text"
                        className="form-control form-control-sm rounded-pill"
                        style={{ maxWidth: 220, fontSize: "0.78rem" }}
                        placeholder="Ej: computadores"
                        value={palabraInput}
                        onChange={e => setPalabraInput(e.target.value)}
                    />
                    <button type="submit" className="btn btn-sm btn-outline-secondary rounded-pill" style={{ fontSize: "0.78rem" }}>
                        <i className="bi bi-search"></i>
                    </button>
                    {palabra && (
                        <button type="button" className="btn btn-sm btn-link text-danger p-0 text-decoration-none" style={{ fontSize: "0.78rem" }}
                            onClick={() => { setPalabraInput(""); setPalabra(""); setPagina(1); }}>
                            <i className="bi bi-x"></i>
                        </button>
                    )}
                </form>

                {/* Fila 2: categoría */}
                <div className="d-flex gap-2 align-items-center">
                    <span className="text-muted small fw-semibold flex-shrink-0" style={{ fontSize: "0.8rem", minWidth: 80 }}>Categoría:</span>
                    <select
                        className="form-select form-select-sm rounded-pill"
                        style={{ width: "auto", minWidth: 200, fontSize: "0.78rem" }}
                        value={categoria}
                        onChange={cambiarCategoria}
                    >
                        <option value="">Todas</option>
                        {CATEGORIAS_BUSQUEDA.map(c => <option key={c} value={c}>{c}</option>)}
                    </select>
                </div>

                {/* Fila 3: chips de toggle + limpiar */}
                <div className="d-flex gap-2 align-items-center flex-wrap">
                    <button
                        type="button"
                        className={`btn btn-sm rounded-pill ${soloConFiltros ? "btn-primary" : "btn-outline-secondary"}`}
                        style={{ fontSize: "0.78rem" }}
                        onClick={toggleFiltro}
                    >
                        <i className="bi bi-funnel me-1"></i>Solo con búsqueda activa
                    </button>
                    <button
                        type="button"
                        className={`btn btn-sm rounded-pill ${soloConUsuario ? "btn-primary" : "btn-outline-secondary"}`}
                        style={{ fontSize: "0.78rem" }}
                        onClick={() => { setSoloConUsuario(v => !v); setPagina(1); }}
                    >
                        <i className="bi bi-person-check me-1"></i>Solo con usuario
                    </button>
                    {hayFiltros && (
                        <button type="button" className="btn btn-sm btn-link text-danger p-0 text-decoration-none" style={{ fontSize: "0.78rem" }}
                            onClick={limpiarTodo}>
                            <i className="bi bi-x me-1"></i>Limpiar filtros
                        </button>
                    )}
                </div>
            </div>

            {cargando ? (
                <div className="text-center py-5">
                    <span className="spinner-border text-primary" role="status" />
                </div>
            ) : busquedas.length === 0 ? (
                <div className="border rounded-4 p-5 bg-light text-center">
                    <i className="bi bi-search fs-2 text-muted"></i>
                    <p className="text-muted small mb-0 mt-2">Aún no hay búsquedas registradas.</p>
                </div>
            ) : (
                <>
                    <p className="text-muted small mb-3">
                        {total} búsqueda{total !== 1 ? "s" : ""} · página {pagina} de {paginas}
                    </p>

                    <div className="d-flex flex-column gap-2">
                        {busquedas.map((b) => {
                            const nombreUsuario = b.usuario
                                ? ([b.usuario.nombre, b.usuario.apellido].filter(Boolean).join(" ") || b.usuario.username)
                                : null;

                            return (
                                <div key={b._id || b.idBusqueda} className="card border-0 shadow-sm rounded-4">
                                    <div className="card-body py-3 px-4">
                                        <div className="d-flex align-items-start gap-3 flex-wrap justify-content-between">
                                            <div className="flex-grow-1 min-w-0">
                                                <div className="d-flex align-items-center gap-2 flex-wrap mb-2">
                                                    {b.palabra && (
                                                        <span className="badge rounded-pill px-2 py-1" style={{ background: "rgba(var(--azul-bootstrap-cta-rgb), 0.1)", color: "var(--azul-bootstrap-cta)", fontSize: "0.72rem" }}>
                                                            <i className="bi bi-search me-1"></i>{b.palabra}
                                                        </span>
                                                    )}
                                                    {b.categoria && (
                                                        <span className="badge rounded-pill px-2 py-1" style={{ background: "rgba(var(--verde-bootstrap-rgb), 0.1)", color: "var(--verde-bootstrap)", fontSize: "0.72rem" }}>
                                                            {b.categoria}
                                                        </span>
                                                    )}
                                                    {b.subcategoria && (
                                                        <span className="badge rounded-pill px-2 py-1" style={{ background: "rgba(var(--verde-bootstrap-rgb), 0.1)", color: "var(--verde-bootstrap)", fontSize: "0.72rem" }}>
                                                            {b.subcategoria}
                                                        </span>
                                                    )}
                                                    {b.ciudad && (
                                                        <span className="badge rounded-pill px-2 py-1" style={{ background: "rgba(var(--violeta-bootstrap-rgb), 0.1)", color: "var(--violeta-bootstrap)", fontSize: "0.72rem" }}>
                                                            <i className="bi bi-geo-alt me-1"></i>{b.ciudad}
                                                        </span>
                                                    )}
                                                    {b.ordenar && (
                                                        <span className="badge rounded-pill px-2 py-1" style={{ background: "rgba(var(--amarillo-warning-rgb), 0.15)", color: "var(--dorado-oscuro)", fontSize: "0.72rem" }}>
                                                            {LABEL_ORDENAR[b.ordenar] || b.ordenar}
                                                        </span>
                                                    )}
                                                    {b.precioMax > 0 && (
                                                        <span className="badge rounded-pill px-2 py-1" style={{ background: "rgba(var(--rojo-error-rgb), 0.1)", color: "var(--rojo-error)", fontSize: "0.72rem" }}>
                                                            Hasta {fmtMonto(b.precioMax)}
                                                        </span>
                                                    )}
                                                    {!b.palabra && !b.categoria && !b.subcategoria && !b.ciudad && !b.ordenar && !(b.precioMax > 0) && (
                                                        <span className="text-muted small">Sin filtros (búsqueda general)</span>
                                                    )}
                                                </div>
                                                <div className="text-muted small">
                                                    <i className="bi bi-calendar3 me-1"></i>{fmtFecha(b.createdAt || b.fecha)}
                                                    <span className="ms-3">
                                                        <i className={`bi ${b.origen === "app" ? "bi-phone" : "bi-window"} me-1`}></i>
                                                        {b.origen === "app" ? "App" : "Web"}
                                                    </span>
                                                    {Number.isFinite(b.total) && (
                                                        <span className="ms-3"><i className="bi bi-list-ul me-1"></i>{b.total} resultado{b.total !== 1 ? "s" : ""}</span>
                                                    )}
                                                </div>
                                                {b.idBusqueda && (
                                                    <div className="text-muted mt-1" style={{ fontSize: "0.68rem" }} title="Mismo id que EventoPropio (search_performed/search_no_results) y los eventos de Meta/GA4/TikTok — úsalo para cruzar esta búsqueda con su registro de analítica.">
                                                        <i className="bi bi-link-45deg me-1"></i>
                                                        <span className="font-monospace">{b.idBusqueda}</span>
                                                    </div>
                                                )}
                                            </div>

                                            <div className="flex-shrink-0 text-end">
                                                {b.usuario ? (
                                                    <div className="d-flex align-items-center gap-2">
                                                        <img
                                                            src={b.usuario.avatar || "/imagenes/marca/avatar.png"}
                                                            alt={b.usuario.username || "avatar"}
                                                            className="rounded-circle"
                                                            style={{ width: 32, height: 32, objectFit: "cover" }}
                                                        />
                                                        <div className="text-start">
                                                            <div className="fw-semibold text-dark" style={{ fontSize: "0.85rem", lineHeight: 1.1 }}>{nombreUsuario}</div>
                                                            <div className="text-muted" style={{ fontSize: "0.75rem" }}>@{b.usuario.username}</div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <span className="badge rounded-pill px-2 py-1" style={{ background: "rgba(var(--gris-suave-rgb), 0.1)", color: "var(--gris-suave)", fontSize: "0.72rem" }}>
                                                        <i className="bi bi-person me-1"></i>Sin usuario
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    {paginas > 1 && (
                        <nav className="mt-4">
                            <ul className="pagination pagination-sm justify-content-center gap-1 flex-wrap">
                                <li className={`page-item ${pagina === 1 ? "disabled" : ""}`}>
                                    <button className="page-link rounded-3 border-0 shadow-sm" onClick={() => cambiarPagina(pagina - 1)}>
                                        <i className="bi bi-chevron-left"></i>
                                    </button>
                                </li>
                                {Array.from({ length: paginas }, (_, i) => i + 1)
                                    .filter(p => p <= 2 || p >= paginas - 1 || Math.abs(p - pagina) <= 2)
                                    .reduce((acc, p, idx, arr) => {
                                        if (idx > 0 && p - arr[idx - 1] > 1) acc.push("...");
                                        acc.push(p);
                                        return acc;
                                    }, [])
                                    .map((p, i) =>
                                        p === "..." ? (
                                            <span key={`e-${i}`} className="text-muted px-1 align-self-center">…</span>
                                        ) : (
                                            <button
                                                key={p}
                                                className={`btn btn-sm rounded-3 px-3 ${p === pagina ? "btn-dark" : "btn-outline-secondary"}`}
                                                onClick={() => cambiarPagina(p)}
                                            >
                                                {p}
                                            </button>
                                        )
                                    )
                                }
                                <li className={`page-item ${pagina === paginas ? "disabled" : ""}`}>
                                    <button className="page-link rounded-3 border-0 shadow-sm" onClick={() => cambiarPagina(pagina + 1)}>
                                        <i className="bi bi-chevron-right"></i>
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    )}
                </>
            )}
        </div>
    );
}

export default Busquedas;
